'use client';
import { useSession } from '@shared/auth';

function LoggedIn({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useSession();
  return isAuthenticated ? <>{children}</> : null;
}

function LoggedOut({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useSession();
  return isAuthenticated ? null : <>{children}</>;
}

export { LoggedIn, LoggedOut };
